import React, { createContext, useContext, useState } from "react";

const PayrollCycleContext = createContext();

export const usePayrollCycleRun = () => {
  const context = useContext(PayrollCycleContext);
  if (!context) {
    throw new Error("useShiftRota must be used within a ShiftRotaProvider");
  }
  return context;
};

export const PayrunCycleProvider = ({ children }) => {
  const [attendanceDayDetails, setAttendanceDayDetails] = useState([]);
  const [attendanceData, setAttendanceData] = useState([]);
  const [logData, setLogData] = useState([]);
  const [payScheduleData, setPayScheduleData] = useState([]);
  const [initiatePayrun, setInitiatePayrun] = useState(false);
  const [paymentBasedOn, setPaymentBasedOn] = useState("Shift");
  const [payScheduleId, setPayScheduleId] = useState("");
  const [activeTab, setActiveTab] = useState(0);
  const [viewPayRunScreen, setViewPayRunScreen] = useState(false);
  const [userId, setUserId] = useState("");
  const [getCompanyId, setGetCompanyId] = useState("");
  const [isProcessing, setIsProcessing] = useState(false);
  const [processingMessage, setProcessingMessage] = useState("");
  const [socketCompleted, setSocketCompleted] = useState(false);
  const [rerunLoader, setRerunLoader] = useState(false);
  const [recallEmployeeApi, setRecallEmployeeApi] = useState(false);
  const [hanldeLoader, setHanldeLoader] = useState(true);
  const [recallSummaryApi, setRecallSummaryApi] = useState(false);
  const [getUpdatedData, setGetUpdatedData] = useState(false);
  const [taskProgress, setTaskProgress] = useState({
    active: false,
    progress: 0,
    message: "",
    status: null,
    taskId: null,
    websocketUrl: null,
  });
  const [socket, setSocket] = useState(null);

  const value = {
    attendanceDayDetails,
    setAttendanceDayDetails,
    attendanceData,
    setAttendanceData,
    logData,
    setLogData,
    payScheduleData,
    setPayScheduleData,
    initiatePayrun,
    setInitiatePayrun,
    paymentBasedOn,
    setPaymentBasedOn,
    payScheduleId,
    setPayScheduleId,
    activeTab,
    setActiveTab,
    viewPayRunScreen,
    setViewPayRunScreen,
    userId,
    setUserId,
    isProcessing,
    setIsProcessing,
    processingMessage,
    setProcessingMessage,
    socketCompleted,
    setSocketCompleted,
    taskProgress,
    setTaskProgress,
    socket,
    getCompanyId,
    setGetCompanyId,
    setSocket,
    rerunLoader,
    setRerunLoader,
    recallEmployeeApi,
    setRecallEmployeeApi,
    getUpdatedData,
    setGetUpdatedData,
    hanldeLoader,
    setHanldeLoader,
    recallSummaryApi,
    setRecallSummaryApi,
  };

  return (
    <PayrollCycleContext.Provider value={value}>
      {children}
    </PayrollCycleContext.Provider>
  );
};
